import { useEffect } from 'react';

import { useShowBackerInfoForCause } from '@givebacks/api/backer';
import { useForm } from '@givebacks/formy';

import { phoneNumberDisplayFormat } from '../../../../../../utils';
import { ClickableOptionsCard } from '../../../../../Cards/ClickableOptionsCard/ClickableOptionsCard';

type CauseDirectorySettingsFormType = {
  inDirectory: boolean;
  showEmail: boolean;
  showPhone: boolean;
};

const CauseDirectorySettingsForm = ({ causeId }: { causeId: string }) => {
  const { data: backer } = useShowBackerInfoForCause({ causeId });

  const form = useForm<CauseDirectorySettingsFormType>(
    {
      initialValues: {
        inDirectory: false,
        showEmail: false,
        showPhone: false,
      },
      enhanceGetInputProps: (payload) => ({
        disabled:
          form.values.inDirectory === false &&
          (payload.field === 'showEmail' || payload.field === 'showPhone'),
      }),
    },
    {
      id: 'directorySettings',
    }
  );

  useEffect(() => {
    if (backer) {
      form.initialize({
        inDirectory: backer.show_in_directory,
        showEmail: backer.show_email,
        showPhone: backer.show_phone,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backer]);
  return (
    <ClickableOptionsCard variant="gray">
      <ClickableOptionsCard.Switch
        title="Visible in directory"
        subtitle="Show or hide your profile"
        {...form.getInputProps('inDirectory', { type: 'checkbox' })}
      />
      <ClickableOptionsCard.Switch
        title="Show my email"
        subtitle={backer?.email}
        disabled={form.values.inDirectory === false}
        {...form.getInputProps('showEmail', { type: 'checkbox' })}
      />
      <ClickableOptionsCard.Switch
        title="Show my phone number"
        subtitle={phoneNumberDisplayFormat(backer?.phone_number ?? '') || '(###) ###-####'}
        disabled={form.values.inDirectory === false}
        {...form.getInputProps('showPhone', { type: 'checkbox' })}
      />
    </ClickableOptionsCard>
  );
};

export { CauseDirectorySettingsForm };
export type { CauseDirectorySettingsFormType };
